import React, { useState } from 'react';
import Tile from '../ui/Tile';
import TileHeader from '../ui/TileHeader';
import { Repeat } from 'lucide-react';
import AutoListTable from './components/AutoListTable';
import HistoryToolbar from '../invoices-history/components/HistoryToolbar';
import HistoryPagination from '../invoices-history/components/HistoryPagination';
import InvoiceFilters from '../invoices-history/components/InvoiceFilters';

const AutomaticInvoicesList = ({
  invoices = [],
  sorting,
  setSorting,
  page,
  setPage,
  totalPages,
  totalElements,
  size,
  setSize,
  filters,
  setFilters,
  handleDeleteRecurringInvoice,
  handleLoadInvoiceToForm,
  handleUpdateRecurringInvoice
}) => {
  const [showFilters, setShowFilters] = useState(false);

  const handleToggleFilters = () => {
    setShowFilters(prev => !prev);
  };

  const handleLoadAll = () => {
    setSize(totalElements);
    setPage(0);
  };


  return (
    <div className="w-full mt-8">
      <Tile>
        <TileHeader title="Автоматични фактури" icon={Repeat} />
        
        <HistoryToolbar 
          loadedCount={invoices.length}
          totalCount={totalElements || invoices.length}
          onToggleFilters={handleToggleFilters}
          showFilters={showFilters}
          hasFilters={!!setFilters}
          onLoadAll={handleLoadAll}
        />
        {showFilters && setFilters && (
          <InvoiceFilters 
            filters={filters || {}} 
            setFilters={setFilters} 
            isRecurring={true}
            onClose={handleToggleFilters}
          />
        )}

        <div className="pt-6">
          <AutoListTable 
            invoices={invoices}
            sorting={sorting}
            setSorting={setSorting}
            handleDeleteRecurringInvoice={handleDeleteRecurringInvoice}
            handleLoadInvoiceToForm={handleLoadInvoiceToForm}
            handleUpdateRecurringInvoice={handleUpdateRecurringInvoice}
          />
        </div>
        
        <HistoryPagination 
          page={page}
          setPage={setPage}
          totalPages={totalPages}
        />
      </Tile>
    </div>
  );
};

export default AutomaticInvoicesList;
